const {
  runDateExtender: baseRunDateExtender
} = require('vue-js-extender');

exports.runDateExtender = (Vue) => {
  baseRunDateExtender(Vue);

  //------------------------- Date Extensions -------------------------
  //------------------------- End -------------------------
};



// WEBPACK FOOTER //
// ./src/core/js-extender/date.extender.js